module.exports = __webpack_public_path__ + "img/face.3dd09a93.png";